import { Component, Input, OnInit } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { CookieService } from "ngx-cookie-service";
import { environment } from "@mypxplat/xplat/core";

@Component({
  selector: "exc-exchange-header",
  templateUrl: "exchange-header.component.html",
  standalone: false,
})
export class ExchangeHeaderComponent extends BaseComponent implements OnInit {
  @Input() onlyDisplayUser: boolean;
  cookieUser: any;

  public env = environment;

  constructor(
    userService: UserService,
    private cookieService: CookieService
  ) {
    super(userService);
  }

  ngOnInit() {}
}
